import React from 'react';

interface TeamAvatarProps {
  name: string;
  title: string;
}

const TeamAvatar: React.FC<TeamAvatarProps> = ({ name, title }) => {
  // Get initials from name
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  // Determine color scheme based on title
  const getColorScheme = (title: string) => {
    if (title.includes('Founder') || title.includes('CTO')) {
      return {
        bg: 'from-blue-500 to-blue-600',
        icon: '💡', // Innovation/Tech
      };
    }
    if (title.includes('Chief Planning') || title.includes('Officer')) {
      return {
        bg: 'from-purple-500 to-purple-600',
        icon: '📊', // Strategy/Planning
      };
    }
    if (title.includes('Training') || title.includes('Education') || title.includes('VP')) {
      return {
        bg: 'from-green-500 to-emerald-600',
        icon: '🎓', // Education
      };
    }
    return {
      bg: 'from-indigo-500 to-indigo-600',
      icon: '👤',
    };
  };

  const { bg, icon } = getColorScheme(title);

  return (
    <div className={`w-full h-full bg-gradient-to-br ${bg} flex items-center justify-center relative overflow-hidden`}>
      {/* Decorative pattern background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-40 h-40 bg-white rounded-full transform translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-white rounded-full transform -translate-x-1/2 translate-y-1/2" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center">
        {/* Large initials */}
        <div className="text-5xl font-bold text-white mb-2">{initials}</div>

        {/* Role icon */}
        <div className="text-4xl">{icon}</div>

        {/* Subtle title hint */}
        <div className="text-xs text-white/60 mt-2 font-semibold uppercase tracking-wider px-2 text-center">
          {title.split(' ')[0]}
        </div>
      </div>

      {/* Shiny overlay effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none" />
    </div>
  );
};

export default TeamAvatar;
